const SDKSnippets = [
  {
    language: 'jsx',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      _privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) =>
      `//In order to use the SDK, you need to provide it with a few configuration parameters. 
//The configuration parameters can be applied directly to the IKImage component or using 
//an IKContext component.

<IKContext
  publicKey="${publicKey}"
  urlEndpoint="${urlEndpoint}"
  transformationPosition="path"
  authenticationEndpoint="http://www.yourserver.com/auth">

  // Image component
  <IKImage path="/default-image.jpg" transformation={[{
    "height": "300",
    "width": "400"
  }]} />

  // Image upload
  <IKUpload fileName="my-upload" />
</IKContext>`,
    tabLabel: 'React',
  },
  {
    language: 'jsx',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      _privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) =>
      `//In order to use the SDK, you need to provide it with a few configuration parameters. 
//The configuration parameters must be passed to the ImagekitioAngularModule module 
//in your app.module.ts file.

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ImagekitioAngularModule.forRoot({
            publicKey: "${publicKey}", // or environment.publicKey
            urlEndpoint: "${urlEndpoint}", // or environment.urlEndpoint
            authenticationEndpoint: "http://www.yourserver.com/auth" // or environment.authenticationEndpoint
        })
    ],
    providers: [],
    bootstrap: [AppComponent]
})

// Image render using path
<ik-image path="/default-image.jpg" transformation={[{
    "height": "300",
    "width": "400"
  }]}></ik-image>

// Simple upload
<ik-upload fileName="my-upload" /></ik-upload>

// Upload using callbacks and other parameters of upload API
<ik-upload fileName="test_new" [useUniqueFileName]="false" [isPrivateFile]="true"
    (onSuccess)="handleUploadSuccess($event)" (onError)="handleUploadError($event)"></ik-upload>
`,
    tabLabel: 'Angular',
  },
  {
    language: 'jsx',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      _privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) =>
      `//In order to use the SDK, you need to provide it with a few configuration parameters. 
//The configuration parameters can be applied directly to the IKImage component or 
//using an IKContext component.

<IKContext
  publicKey="${publicKey}"
  urlEndpoint="${urlEndpoint}"
  transformationPosition="path"
  authenticationEndpoint="http://www.yourserver.com/auth">

  // Image component
  <IKImage path="/default-image.jpg" transformation={[{
    "height": "300",
    "width": "400"
  }]} />

  // Image upload
  <IKUpload fileName="my-upload" />
</IKContext>`,
    tabLabel: 'Vue.js',
  },
  {
    language: 'kotlin',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      _privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `import com.imagekit.android.ImageKit;

ImageKit.init(
    context = applicationContext,
    publicKey = "${publicKey}",
    urlEndpoint = "${urlEndpoint}",
    transformationPosition = TransformationPosition.PATH,
    authenticationEndpoint = "http://www.yourserver.com/auth"
)

// ${urlEndpoint}/default-image.jpg?tr=h-400.00,ar-3-2
ImageKit.getInstance()
        .url(
            path = "default-image.jpg",
            transformationPosition = TransformationPosition.QUERY
        )
        .height(400f)
        .aspectRatio(3, 2)
        .create()

// File upload
ImageKit.getInstance().uploader().uploadImage(
    file = bitmap!!
    , fileName = filename
    , useUniqueFilename = false
    , tags = arrayOf("nice", "copy", "books")
    , folder = "/dummy/folder/"
    , imageKitCallback = this
)`,
    tabLabel: 'Android (kotlin)',
  },
  {
    language: 'java',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      _privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `import com.imagekit.android.ImageKit;

ImageKit.Companion.init(
    getApplicationContext(),
    "${publicKey}",
    "${urlEndpoint}",
    TransformationPosition.PATH,
    "http://www.yourserver.com/auth"
);

// ${urlEndpoint}/default-image.jpg?tr=h-400.00,ar-3-2
ImageKit.Companion.getInstance()
        .url(
            "default-image.jpg",
            TransformationPosition.QUERY
        )
        .height(400f)
        .aspectRatio(3, 2)
        .create()

// File upload
ImageKit.Companion.getInstance().uploader().uploadImage(
    bitmap,
    filename,
    false, // useUniqueFilename
    new String[]{"nice", "copy", "books"}, // tags, 
    "/dummy/folder/", 
    imageKitCallback
)`,
    tabLabel: 'Android (java)',
  },
  {
    language: 'javascript',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      _privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `// SDK initialization

var imagekit = new ImageKit({
    publicKey : "${publicKey}",
    urlEndpoint : "${urlEndpoint}",
    authenticationEndpoint : "http://www.yourserver.com/auth",
});

// URL generation
var imageURL = imagekit.url({
    path : "/default-image.jpg",
    transformation : [{
        "height" : "300",
        "width" : "400"
    }]
});

// Upload function internally uses the ImageKit.io javascript SDK
function upload(data) {
    var file = document.getElementById("file1");
    imagekit.upload({
        file : file.files[0],
        fileName : "abc1.jpg",
        tags : ["tag1"]
    }, function(err, result) {
        console.log(arguments);
        console.log(imagekit.url({
            src: result.url,
            transformation : [{ height: 300, width: 400}]
        }));
    })
}`,
    tabLabel: 'Javascript',
  },
  {
    language: 'python',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `# SDK initialization

from imagekitio import ImageKit
imagekit = ImageKit(
    private_key='${privateKey}',
    public_key='${publicKey}',
    url_endpoint='${urlEndpoint}'
)`,
    tabLabel: 'Python',
  },
  {
    language: 'javascript',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `// SDK initialization

var ImageKit = require("imagekit");

var imagekit = new ImageKit({
    publicKey : "${publicKey}",
    privateKey : "${privateKey}",
    urlEndpoint : "${urlEndpoint}"
});`,
    tabLabel: 'Node.js',
  },
  {
    language: 'ruby',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `# Add this configuration to config/environments/development.rb 
# and config/environments/production.rb

config.imagekit={
    private_key: "${privateKey}",
    public_key: "${publicKey}",
    url_endpoint: "${urlEndpoint}"
}`,
    tabLabel: 'Ruby and ROR',
  },
  {
    language: 'java',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `/*
    Create a config.properties file inside src/main/resources of your project. 
    And put essential values of keys (UrlEndpoint, PrivateKey, PublicKey), no need to use quote
    in values. Then you need to initialize ImageKit with that configuration.

    UrlEndpoint=${urlEndpoint}
    PrivateKey=${privateKey}
    PublicKey=${publicKey}
*/

import io.imagekit.sdk.ImageKit;
import io.imagekit.sdk.config.Configuration;
import io.imagekit.sdk.utils.Utils;

class App {
   public static void main(String[] args) {
       ImageKit imageKit=ImageKit.getInstance();
       Configuration config=Utils.getSystemConfig(App.class);
       imageKit.setConfig(config);
   }
}`,
    tabLabel: 'Java',
  },
  {
    language: 'php',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `// SDK initialization

// Require the Composer autoloader.
require 'vendor/autoload.php';
use ImageKit\\ImageKit;  

$imageKit = new ImageKit(
    "${publicKey}",
    "${privateKey}",
    "${urlEndpoint}"
);`,
    tabLabel: 'PHP',
  },
  {
    language: 'cs',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `// SDK initialization

using Imagekit;

Imagekit.Imagekit imagekit = new Imagekit.Imagekit(
    "${publicKey}", 
    "${privateKey}", 
    "${urlEndpoint}", 
    "path"
);`,
    tabLabel: '.NET',
  },
  {
    language: 'Go',
    codeString: (
      publicKey = 'YOUR_PUBLIC_KEY',
      privateKey = 'YOUR_PRIVATE_KEY',
      urlEndpoint = 'YOUR_ENDPOINT',
    ) => `// SDK initialization

import (
  "github.com/imagekit-developer/imagekit-go"
)

// Using environment variables IMAGEKIT_PRIVATE_KEY, IMAGEKIT_PUBLIC_KEY and IMAGEKIT_ENDPOINT_URL
ik, err := ImageKit.New()

// Using keys in argument
ik, err := ImageKit.NewFromParams(imagekit.NewParams{
  PrivateKey: "${privateKey}",
  PublicKey: "${publicKey}",
  UrlEndpoint: "${urlEndpoint}"
})`,
    tabLabel: 'Go',
  },
]

export default SDKSnippets
